import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "row mb-4"
};
const _hoisted_2 = { class: "col-sm-6 col-xl-3" };
const _hoisted_3 = { class: "stat-card stat-card--blue" };
const _hoisted_4 = { class: "stat-card__body" };
const _hoisted_5 = { class: "stat-card__value" };
const _hoisted_6 = { class: "col-sm-6 col-xl-3" };
const _hoisted_7 = { class: "stat-card stat-card--green" };
const _hoisted_8 = { class: "stat-card__body" };
const _hoisted_9 = { class: "stat-card__value" };
const _hoisted_10 = { class: "col-sm-6 col-xl-3" };
const _hoisted_11 = { class: "stat-card stat-card--orange" };
const _hoisted_12 = { class: "stat-card__body" };
const _hoisted_13 = { class: "stat-card__value" };
const _hoisted_14 = { class: "col-sm-6 col-xl-3" };
const _hoisted_15 = { class: "stat-card stat-card--purple" };
const _hoisted_16 = { class: "stat-card__body" };
const _hoisted_17 = { class: "stat-card__value" };
const _hoisted_18 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_19 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" };
const _hoisted_20 = { class: "d-flex align-items-center gap-3 flex-wrap" };
const _hoisted_21 = { class: "d-flex align-items-center gap-2 mt-3 mt-lg-0" };
const _hoisted_22 = {
    key: 0,
    class: "ri-global-line me-1"
};
const _hoisted_23 = {
    key: 1,
    class: "ri-store-line me-1"
};
const _hoisted_24 = {
    key: 0,
    class: "text-center py-5"
};
const _hoisted_25 = {
    key: 1,
    class: "empty-state py-5 text-center"
};
const _hoisted_26 = {
    key: 2,
    class: "p-15 p-sm-20 p-md-25"
};
const _hoisted_27 = { class: "row g-3" };
const _hoisted_28 = { class: "modal-card" };
const _hoisted_29 = { class: "modal-card__text text-muted" };
const _hoisted_30 = { class: "d-flex gap-2 justify-content-center mt-3" };
const _hoisted_31 = ["disabled"];
const _hoisted_32 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-1"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BreadCrumb = _resolveComponent("BreadCrumb");
    const _component_v_select = _resolveComponent("v-select");
    const _component_LoyaltyProductCard = _resolveComponent("LoyaltyProductCard");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_BreadCrumb, { PageTitle: "Produits Fidélité" }),
        (_ctx.stats)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "stat-card__icon" }, [
                            _createElementVNode("i", { class: "ri-trophy-line" })
                        ], -1)),
                        _createElementVNode("div", _hoisted_4, [
                            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "stat-card__label" }, "Total Activations", -1)),
                            _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.stats.totalActivations), 1)
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "stat-card__icon" }, [
                            _createElementVNode("i", { class: "ri-check-double-line" })
                        ], -1)),
                        _createElementVNode("div", _hoisted_8, [
                            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "stat-card__label" }, "Converties", -1)),
                            _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.stats.converted), 1)
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "stat-card__icon" }, [
                            _createElementVNode("i", { class: "ri-timer-line" })
                        ], -1)),
                        _createElementVNode("div", _hoisted_12, [
                            _cache[10] || (_cache[10] = _createElementVNode("p", { class: "stat-card__label" }, "Expirées", -1)),
                            _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.stats.expired), 1)
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "stat-card__icon" }, [
                            _createElementVNode("i", { class: "ri-percent-line" })
                        ], -1)),
                        _createElementVNode("div", _hoisted_16, [
                            _cache[12] || (_cache[12] = _createElementVNode("p", { class: "stat-card__label" }, "Taux conversion", -1)),
                            _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.stats.conversionRate) + "%", 1)
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                    _cache[14] || (_cache[14] = _createElementVNode("h5", { class: "card-title fw-bold mb-0" }, [
                        _createElementVNode("i", { class: "ri-gift-line me-2 text-primary" }),
                        _createTextVNode("Produits Fidélité VA BENE ")
                    ], -1)),
                    (_ctx.userRole === _ctx.UserRole.FRANCHISE)
                        ? (_openBlock(), _createBlock(_component_v_select, {
                            key: 0,
                            modelValue: _ctx.selectedRestaurant,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedRestaurant) = $event)),
                            options: _ctx.restaurantOptions,
                            label: "name",
                            reduce: (r) => r.id,
                            placeholder: "Tous les restaurants",
                            class: "restaurant-select"
                        }, null, 8, ["modelValue", "options", "reduce"]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", {
                        class: _normalizeClass(["badge scope-badge", _ctx.currentScopeClass])
                    }, [
                        (!_ctx.selectedRestaurant)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_22))
                            : (_openBlock(), _createElementBlock("i", _hoisted_23)),
                        _createTextVNode(" " + _toDisplayString(_ctx.selectedRestaurant ? 'Mode LOCAL' : 'Mode GLOBAL'), 1)
                    ], 2),
                    (_ctx.userRole === _ctx.UserRole.FRANCHISE || _ctx.allowLoyaltyCustomization)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-primary btn-sm d-flex align-items-center gap-1",
                            onClick: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => (_ctx.goToCreate && _ctx.goToCreate(...args)))
                        }, [...(_cache[15] || (_cache[15] = [
                                _createElementVNode("i", { class: "ri-add-line" }, null, -1),
                                _createTextVNode(" Créer une récompense ", -1)
                            ]))]))
                        : _createCommentVNode("", true)
                ])
            ]),
            (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[16] || (_cache[16] = [
                        _createElementVNode("div", {
                            class: "spinner-border text-primary",
                            role: "status"
                        }, null, -1),
                        _createElementVNode("p", { class: "mt-2 text-muted small" }, "Chargement des produits fidélité...", -1)
                    ]))]))
                : (_ctx.products.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _cache[18] || (_cache[18] = _createStaticVNode("<div class=\"empty-state__icon\" data-v-1e3cac15><i class=\"ri-gift-2-line\" data-v-1e3cac15></i></div><h6 class=\"empty-state__title\" data-v-1e3cac15>Aucun produit fidélité</h6><p class=\"empty-state__text\" data-v-1e3cac15> Créez votre premier produit fidélité pour récompenser vos clients.<br data-v-1e3cac15><small class=\"text-muted\" data-v-1e3cac15>Exemple : &quot;Pizza Offerte à 1 500 pts&quot; avec timer 60 min</small></p>", 3)),
                        (_ctx.userRole === _ctx.UserRole.FRANCHISE || _ctx.allowLoyaltyCustomization)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-primary mt-2",
                                onClick: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => (_ctx.goToCreate && _ctx.goToCreate(...args)))
                            }, [...(_cache[17] || (_cache[17] = [
                                    _createElementVNode("i", { class: "ri-add-line me-1" }, null, -1),
                                    _createTextVNode("Créer une récompense ", -1)
                                ]))]))
                            : _createCommentVNode("", true)
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: product.id,
                                    class: "col-12 col-sm-6 col-xl-4"
                                }, [
                                    _createVNode(_component_LoyaltyProductCard, {
                                        product: product,
                                        userRole: _ctx.userRole,
                                        userRestaurantId: _ctx.userRestaurantId,
                                        onToggle: _ctx.handleToggle,
                                        onEdit: _ctx.handleEdit,
                                        onDelete: _ctx.handleDelete
                                    }, null, 8, ["product", "userRole", "userRestaurantId", "onToggle", "onEdit", "onDelete"])
                                ]));
                            }), 128))
                        ])
                    ]))
        ]),
        (_ctx.showDeleteModal)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "modal-overlay",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event) => (_ctx.showDeleteModal = false), ["self"]))
            }, [
                _createElementVNode("div", _hoisted_28, [
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "modal-card__icon modal-card__icon--danger" }, [
                        _createElementVNode("i", { class: "ri-delete-bin-line" })
                    ], -1)),
                    _cache[23] || (_cache[23] = _createElementVNode("h6", { class: "modal-card__title" }, "Supprimer ce produit fidélité ?", -1)),
                    _createElementVNode("p", _hoisted_29, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.productToDelete?.name), 1),
                        _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                        _cache[20] || (_cache[20] = _createTextVNode(" Cette action est irréversible. Les activations en cours ne seront pas affectées. ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("button", {
                            class: "btn btn-outline-secondary btn-sm",
                            onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.showDeleteModal = false))
                        }, " Annuler "),
                        _createElementVNode("button", {
                            class: "btn btn-danger btn-sm",
                            onClick: _cache[4] || (_cache[4] =
                                //@ts-ignore
                                (...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args))),
                            disabled: _ctx.deleting
                        }, [
                            (_ctx.deleting)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_32))
                                : _createCommentVNode("", true),
                            _cache[21] || (_cache[21] = _createTextVNode(" Supprimer ", -1))
                        ], 8, _hoisted_31)
                    ])
                ])
            ]))
            : _createCommentVNode("", true)
    ], 64));
}
